<template>
  <transition name="bbFade" @after-enter="showBuyContent = true">
    <div class="modal" v-if="showBuy" @click="showBuyContent = false">
      <transition name="bbUp" @after-leave="closeBuy">
        <div v-show="showBuyContent" class="modal__card" @click.stop="">
          <div class="modal__dialog">
            <div class="modal__header">
              <div class="modal__back" v-show="buyStep > initialStep">
                <img
                  src="../../../assets/img/ico/ico-arrow-back.svg"
                  alt="Atrás"
                  @click="buyStep--"
                />
              </div>
              <div class="modal__title">
                <slot name="titulo" />
              </div>
              <div class="modal__close">
                <img
                  src="../../../assets/img/ico/ico-close.svg"
                  alt="Cerrar"
                  @click="showBuyContent = false"
                />
              </div>
            </div>
            <div class="modal__content" ref="scroll_container">
              <FluxRegaloStep1
                v-if="buyStep === 1"
                :product="product"
                :list="list"
                :retailer="retailer"
                @next="nextFirstStepBuy"
              />
              <FluxRegaloStep2
                v-if="buyStep === 2"
                :product="product"
                :list="list"
                :retailer="retailer"
                @next="nextSecondStepBuy"
              />
              <FluxRegaloStep3
                v-if="buyStep === 3"
                :product="product"
                :list="list"
                :retailer="retailer"
                @next="goToMessageStep"
              />
              <FluxRegaloStep4
                v-if="buyStep === 4"
                :product="product"
                :list="list"
                :retailer="retailer"
              />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import FluxRegaloStep1 from "./FluxRegaloStep1.vue";
import FluxRegaloStep2 from "./FluxRegaloStep2.vue";
import FluxRegaloStep3 from "./FluxRegaloStep3.vue";
import FluxRegaloStep4 from "./FluxRegaloStep4.vue";

export default {
  name: "FluxRegaloWizard",
  components: {
    FluxRegaloStep1,
    FluxRegaloStep2,
    FluxRegaloStep3,
    FluxRegaloStep4,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    list: {
      type: Object,
      required: true,
    },
    retailer: {
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    initialStep: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      showBuy: false,
      showBuyContent: false,
      buyStep: 1,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        document.body.classList.add("modal-open");
        this.showBuy = true;
      } else {
        this.showBuy = false;
        document.body.classList.remove("modal-open");
      }
    },
    showBuy(val) {
      if (!val) {
        document.body.classList.remove("modal-open");
      }
    },
  },
  computed: {
    productRetailersName() {
      return this.product?.productRetailers?.map(r => r.name).join(", ") || "";
    },
    SoldByHelloBB() {
      return this.product?.soldByHelloBB || false;
    },
  },
  methods: {
    nextFirstStepBuy() {
      window.mixpanel.identify(this.list.userId);
      window.mixpanel.track("Redireccionar a retailer", {
        "Object name": this.product.name,
        "Selected Vendor": this.retailer?.name,
        "Object price": this.product.price,
        "List URL": `https://www.hellobb.net/guest/${this.list.id}`,
        "Buyer role": "Convidat",
        Src: "fitxa del regalador",
        "Sold by HelloBB": this.SoldByHelloBB,
        "Item Retailers": this.productRetailersName,
      });
      this.buyStep++;
      this.resetScroll();
    },
    nextSecondStepBuy() {
      this.buyStep++;
      this.resetScroll();
    },
    goToMessageStep() {
      this.buyStep++;
      this.resetScroll();
    },
    closeBuy() {
      this.showBuy = false;
      if (this.buyStep > 2) {
        this.$store.commit("setListUpdated", false);
      }
      document.body.classList.remove("modal-open");
      if(this.buyStep > 2) this.$store.commit("setOpenLoopModal", true);
      this.buyStep = this.initialStep;
      this.$emit("close");
    },
    resetScroll() {
      this.$refs.scroll_container?.scrollTo?.({ top: 0, behavior: "smooth" });
    },
  },
  mounted() {
    this.buyStep = this.initialStep;
  },
};
</script>
